import { SpinnerBody, SpinnerProps } from "./spinner.styles";

export const Spinner = (props: SpinnerProps) => {
  return <SpinnerBody {...props} />;
};
